package se.mittpass.web.components

import se.mittpass.web.*
import se.mittpass.web.components.*
import se.mittpass.web.pages.*
import se.mittpass.web.viewmodel.*
import se.mittpass.web.style.*


import androidx.compose.runtime.*
import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

@Composable
fun CookieConsentBanner() {
    var visible by remember {
        mutableStateOf(localStorage.getItem("mittpass_consent") == null)
    }

    if (!visible) return

    Div({
        style {
            property("position", "fixed")
            property("bottom", "0")
            property("left", "0")
            property("right", "0")
            property("z-index", "9999")
            property("background", "var(--rp-pine)")
            property("border-top", "1px solid rgba(255,255,255,0.08)")
            property("padding", "1.25rem 1.75rem")
            property("display", "flex")
            property("align-items", "center")
            property("justify-content", "space-between")
            property("gap", "1.5rem")
            property("flex-wrap", "wrap")
            property("font-family", "'DM Sans', system-ui, sans-serif")
        }
    }) {
        // Text
        Div({ style { property("flex", "1"); property("min-width", "260px") } }) {
            Span({
                style {
                    property("font-size", "0.88rem")
                    property("color", "rgba(255,255,255,0.75)")
                    property("line-height", "1.6")
                }
            }) {
                Text(LocaleManager.dictionary.cookieNotice)
            }
            A(attrs = {
                href("#")
                onClick { it.preventDefault() }
                style {
                    property("color", "var(--rp-pine)")
                    property("font-size", "0.88rem")
                    property("font-weight", "600")
                    property("text-decoration", "none")
                    property("white-space", "nowrap")
                }
            }) { Text(LocaleManager.dictionary.readMorePolicy) }
        }

        // Buttons
        Div({
            style {
                property("display", "flex")
                property("gap", "0.75rem")
                property("flex-shrink", "0")
            }
        }) {
            // Decline
            Button({
                onClick {
                    localStorage.setItem("mittpass_consent", "declined")
                    visible = false
                }
                style {
                    property("padding", "0.55rem 1.25rem")
                    property("font-size", "0.88rem")
                    property("font-weight", "600")
                    property("font-family", "inherit")
                    property("background", "transparent")
                    property("color", "rgba(255,255,255,0.55)")
                    property("border", "1px solid rgba(255,255,255,0.2)")
                    property("border-radius", "8px")
                    property("cursor", "pointer")
                    property("white-space", "nowrap")
                }
            }) { Text(LocaleManager.dictionary.decline) }

            // Accept
            Button({
                onClick {
                    localStorage.setItem("mittpass_consent", "accepted")
                    js("gtag('consent', 'update', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' })")
                    val englishTitle = LocaleManager.getEnglishTitle(window.location.pathname)
                    js("gtag('event', 'page_view', { page_title: englishTitle, page_location: window.location.href, page_path: window.location.pathname })")
                    visible = false
                }
                style {
                    property("padding", "0.55rem 1.25rem")
                    property("font-size", "0.88rem")
                    property("font-weight", "700")
                    property("font-family", "inherit")
                    property("background", "linear-gradient(135deg, var(--rp-pine), var(--rp-iris))")
                    property("color", "white")
                    property("border", "none")
                    property("border-radius", "8px")
                    property("cursor", "pointer")
                    property("white-space", "nowrap")
                }
            }) { Text(LocaleManager.dictionary.accept) }
        }
    }
}
